// File#: _1_cross-table
// Usage: codyhouse.co/license
(function() {
  var CrossTables = function(element) {
    this.element = element;
    this.header = this.element.getElementsByClassName('js-cross-table__header')[0];
    this.body = this.element.getElementsByClassName('js-cross-table__body')[0];
    this.headerItems = this.header.getElementsByClassName('cross-table__cell');
    this.rows = this.body.getElementsByClassName('cross-table__row');
    this.rowSections = this.element.getElementsByClassName('js-cross-table__row--w-full');
    this.singleLayoutClass = 'cross-table--cards';
    // resize 
    this.resizingId = false;
    initCrossTable(this);
  };

  function initCrossTable(table) {
    setTableRoles(table); // set proper roles
    addTableContent(table); // create additional table content
    setTableLayout(table); // optimize layout for mobile
    resizeTable(table); // reset table layout on resize
  };

  function setTableRoles(table) {
    // table
    table.element.setAttribute('role', 'table');
    // body and header
    table.header.setAttribute('role', 'rowgroup');
    table.body.setAttribute('role', 'rowgroup');
    // tr, th, td
    var trElements = table.element.getElementsByTagName('tr');
    for(var i=0; i < trElements.length; i++) {
      trElements[i].setAttribute('role', 'row');
    }
    var thElements = table.element.getElementsByTagName('th');
    for(var i=0; i < thElements.length; i++) {
      thElements[i].setAttribute('role', 'rowheader');
    }
    var tdElements = table.element.getElementsByTagName('td');
    for(var i=0; i < tdElements.length; i++) {
      tdElements[i].setAttribute('role', 'cell');
    }
  };

  function addTableContent(table) {
    // store header labels
    var headerLables = [];
    for(var i = 0; i < table.headerItems.length; i++) {
      var headerLabelEl = table.headerItems[i].getElementsByClassName('js-cross-table__label'),
        headerLabel = (headerLabelEl.length > 0 ) ? headerLabelEl[0].innerHTML : table.headerItems[i].innerHTML;
      headerLables.push(headerLabel);
    }
    // insert label inside each cell - visible in cards layout only
    for(var i = 0; i < table.rows.length; i++) {
      if( !table.rows[i].classList.contains('js-cross-table__row--w-full') ) {
        var cells = table.rows[i].children;
        for(var j = 1; j < headerLables.length; j++) {
          if(cells[j]) {
            cells[j].innerHTML = '<span aria-hidden="true" class="cross-table__label">'+headerLables[j]+':</span> <span>'+cells[j].innerHTML+'</span>';
          }
        }
      }
    }
  };

  function setTableLayout(table) {
    // reset style for mobile layout
    for(var i = 0; i < table.rowSections.length; i++) {
      table.rowSections[i].setAttribute('style', 'left:'+table.rowSections[i].nextElementSibling.offsetLeft+'px');
    }
  };

  function resizeTable(table) {
    window.addEventListener('resize', function(event){
      clearTimeout(table.resizingId);
      table.resizingId = setTimeout(function() {
        setTableLayout(table);
      }, 300);
    });
  };

  var crossTables = document.getElementsByClassName('js-cross-table');
  if( crossTables.length > 0 ) {
    for( var i = 0; i < crossTables.length; i++) {
      new CrossTables(crossTables[i]);
    }
  }
}());